import { Box, Button, Checkbox, FormControlLabel, FormGroup, Grid, LinearProgress } from '@mui/material';
import {
  DataGridProProps,
  GRID_CHECKBOX_SELECTION_COL_DEF,
  GridCallbackDetails,
  GridColumnOrderChangeParams,
  GridColumnVisibilityModel,
  GridRowClassNameParams,
  GridSelectionModel,
  GridSortModel,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  MuiEvent,
  useGridApiRef,
} from '@mui/x-data-grid-pro';
import { DataGridPro as DataGrid, DataGridPro } from '@mui/x-data-grid-pro/DataGridPro/DataGridPro';
import { difference } from 'lodash';
import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import {
  excludeDeliverablesAction,
  selectAllDeliverablesAction,
  selectDeliverablesAction,
} from 'store/actions/deliverableActions';
import { useSelector } from 'store/hooks';
import { useAppState } from 'store/Provider';
import { columnsParams } from './deliverableTableService';
import { clearSelectedFilterAction, selectFilterAction } from 'store/actions/filterActions';
import Scope from 'types/entities/Scope';
import {
  changePageAction,
  changePageSizeAction,
  filterTotalFlagAction,
  injectTotalWorkunitsBLAction,
  selectAllBLDeliverablesAction,
  selectBLDeliverablesAction,
  selectBLDeliverablesListAction,
  sortChangebaseLineAction,
} from 'store/actions/changeBaselineActions';
import useTotalWorkunitService from './Hooks/useTotalWorkunitService';
import { SearchParams } from 'api/ResourceAPI';
import SearchHeaderCellBL from 'components/SearchHeaderCell/SearchHeaderCellBL';
import SearchHeaderCell from 'components/SearchHeaderCell/SearchHeaderCell';
import { Remove } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { addLoadingAction, removeLoadingAction } from 'store/actions/loadingsActions';
import DeliverableQuickActions from './DeliverableQuickActions/DeliverableQuickActions';
import Loader from 'components/Loader';

type EditTotalWorkunitProps = {
  scopes: Scope[];
};

const CustomToolbar = ({ setFilterButtonEl }: { setFilterButtonEl: any }) => {
  const { dispatch, state } = useAppState();
  const { deliverable } = state;

  const handleSelectAllChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(selectDeliverablesAction([]));
    dispatch(selectAllDeliverablesAction(e.currentTarget.checked));
  };

  // TODO : Fix GridToolbarColumnsButton props, they are temporary set to undefined
  return (
    <Box sx={{ display: 'flex', pl: 1.75 }}>
      {/* <FormGroup>
        <FormControlLabel
          control={
            <Checkbox color="primary" checked={deliverable.selectedAllDeliverables} onChange={handleSelectAllChange} />
          }
          label="Select All"
        />
      </FormGroup> */}
      <GridToolbarContainer sx={{ position: 'relative', ml: 'auto' }}>
        <GridToolbarColumnsButton
          ref={setFilterButtonEl}
          nonce={undefined}
          onResize={undefined}
          onResizeCapture={undefined}
        />
      </GridToolbarContainer>
    </Box>
  );
};

const EditTotalWorkunit = (props: EditTotalWorkunitProps) => {
  const { scopes } = props;
  const { dispatch } = useAppState();
  const [t] = useTranslation();
  const state = useSelector((state) => state.deliverable);
  //  const order = useSelector((state) => state?.deliverable?.order);
  const [isLoading, setIsLoading] = useState(true);
  const apiRef = useGridApiRef();
  const getLocalStorageColumnsStatusKey = (): string => 'baseLineColumnsStatus';
  const getLocalStorageColumnsOrders = useCallback((): string => 'baseLineColumnsStatus', []);

  const {
    baseLineOrder,
    selectedBLDeliverablesModel,
    selectedBLAllDeliverables,
    sortBLtotalWorkunitModel,
    filterTotalWorkunitData,
    totalworkunitData,
    totalItems,
    totalPages,
    filterTotalFlag,
    pageSize,
    currentPage,
    sourceOrder,
  } = useSelector((state) => state.changeBaseline);
  const { handleBLTotalworkunitSearchParams, fetchParamsBLFilterDeliverable } = useTotalWorkunitService();

  const [idsWithName, setIdsWithName] = useState<{ id: number; name: string }[]>([]);
  const [workunitScopes, setWorkunitScopes] = useState<{ id: number; name: string }[]>([]);
  const [po_ref, setPoRef] = useState<{ id: number; name: string }[]>([]);
  const [statusName, setStatusName] = useState<{ id: number; name: string }[]>([]);
  const [tagName, setTagName] = useState<{ id: string; name: string }[]>([]);
  const [currentPageVal, setCurrentPageVal] = useState(0);
  const [filterParamlist, setFilterParamlist] = useState();

  const initialColumnVisibilitySettings = {
    content: true,
    purchase_order: true,
    content2: false,
    content3: false,
    content4: false,
    content5: false,
    amount: false,
    scope: true,
    workunit_desc: false,
    deliverableDate: true,
    forcastedDate: true,
    __check__: true,
    tags: true,
    workunit_reference: true,
    complexity: false,
    cancellation_reason: false,
    modification_reason: false,
    client: true,
    delivery_manager: true,
    submitted: true,
    dm_validation: true,
    client_acceptance: true,
    rating: true,
    comments: true,
    actions: true,
    workunit_name: true,
    consultant: true,
    workload: false,
    OrderWorkUnits_ID: false,
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState(() => {
    const localStorageValue = localStorage.getItem(getLocalStorageColumnsStatusKey());
    if (localStorageValue) {
      return JSON.parse(localStorageValue);
    }
    return initialColumnVisibilitySettings;
  });
  const [columnsOrders, setColumnsOrders] = useState(
    JSON.parse(localStorage.getItem(getLocalStorageColumnsOrders()) || '{}')
  );
  // const [currentPage, setCurrentPage] = useState(0);

  const onColumnVisibilityModelChange = (model: GridColumnVisibilityModel) => {
    setColumnVisibilityModel(model);
    localStorage.setItem(getLocalStorageColumnsStatusKey(), JSON.stringify(model));
  };
  const onColumnOrderChange = useCallback(
    (params: GridColumnOrderChangeParams, event: MuiEvent, details: any) => {
      const { field, targetIndex } = params; // Destructure column Name // and it's target Index
      if (columnsOrders[field] === targetIndex) return;
      setColumnsOrders((prevState: any) => ({
        ...prevState,
        [field]: targetIndex,
      }));
      localStorage.setItem(getLocalStorageColumnsOrders(), JSON.stringify(columnsOrders));
    },
    [columnsOrders, getLocalStorageColumnsOrders]
  );

  useEffect(() => {
    Object.entries(columnsOrders).forEach(([key, value]) => {
      const actualIndex = apiRef.current.getColumnIndex(key);
      if (actualIndex !== value) apiRef.current.setColumnIndex(key, value as number);
    });
  }, [columnsOrders]);

  useEffect(() => {
    // idsWithName
    const ids =
      filterParamlist?.workunit_reference?.map((item) => ({
        id: item,
        name: item.toString(),
      })) || [];
    setIdsWithName(ids);

    // workunitScopes
    const duplicateScopes =
      totalworkunitData?.map((item) => ({
        id: item?.scope?.id,
        name: item?.scope?.name,
      })) || [];
    const uniqueScopes = Array.from(new Set(duplicateScopes.map((item) => JSON.stringify(item)))).map((itemString) =>
      JSON.parse(itemString)
    );
    // setWorkunitScopes(uniqueScopes);
    setWorkunitScopes(filterParamlist?.scopes);

    // po_ref
    const duplicatepo_ref =
      totalworkunitData?.map((item) => ({
        id: item.purchase_order_id,
        name: item.purchase_order,
      })) || [];
    const uniquePoRef = Array.from(new Set(duplicatepo_ref.map((item) => JSON.stringify(item)))).map((itemString) =>
      JSON.parse(itemString)
    );
    // setPoRef(uniquePoRef);

    const purchase_list =
      filterParamlist?.purchase_orders?.map((item) => ({
        id: item,
        name: item.toString(),
      })) || [];
    // setIdsWithName(ids);

    setPoRef(purchase_list);

    // statusName
    const duplicateStatus =
      totalworkunitData?.map((item) => {
        let status = '';
        switch (item.mission_advancement_id) {
          case 1:
            status = 'SUBMITTED';
            break;
          case 2:
            status = 'DM REFUSE';
            break;
          case 3:
            status = 'DM ACCEPTED';
            break;
          case 4:
            status = 'DM VALIDATED WITH RESERVATION';
            break;
          case 5:
            status = 'CLIENT REFUSE';
            break;
          case 6:
            status = 'CLIENT ACCEPTED WITH RESERVATION';
            break;
          case 7:
            status = 'CLIENT ACCEPTED';
            break;
          default:
            status = 'NOT SUBMITTED';
        }
        return {
          id: item.mission_advancement_id ? item.mission_advancement_id : 100,
          name: status,
        };
      }) || [];
    const uniqueStatus = Array.from(new Set(duplicateStatus.map((item) => JSON.stringify(item)))).map((itemString) =>
      JSON.parse(itemString)
    );

    const ALL_STATUSES = [
      { id: 1, name: 'SUBMITTED' },
      { id: 2, name: 'DM REFUSE' },
      { id: 3, name: 'DM ACCEPTED' },
      { id: 4, name: 'DM VALIDATED WITH RESERVATION' },
      { id: 5, name: 'CLIENT REFUSE' },
      { id: 6, name: 'CLIENT ACCEPTED WITH RESERVATION' },
      { id: 7, name: 'CLIENT ACCEPTED' },
      { id: 100, name: 'NOT SUBMITTED' },
      { id: 101, name: 'CANCELLED' },
      { id: 102, name: 'DELETED' },
    ];

    setStatusName(ALL_STATUSES);

    // tagName
    const labelSet = new Set();
    totalworkunitData?.forEach((item) => {
      const labels = item.label?.split('|') || [];
      labels.forEach((label) => {
        if (label) labelSet.add(label.trim());
      });
    });
    const tags = Array.from(labelSet).map((label) => {
      const value = label === 'quote' ? 'Lastbaseline' : label;
      const valueStr = String(value);
      return {
        id: label,
        name: valueStr.charAt(0).toUpperCase() + valueStr.slice(1),
      };
    });

    const optionsList = [
      {
        id: 'quote',
        name: 'Last Baseline',
      },
      {
        id: 'custom',
        name: 'Custom',
      },
      {
        id: 'added',
        name: 'Added',
      },
      {
        id: 'updated',
        name: 'Updated',
      },
      {
        id: 'cancelled',
        name: 'Cancelled',
      },
      {
        id: 'Deleted',
        name: 'Deleted',
      },
      {
        id: 'New WU',
        name: 'New WU',
      },
    ];
    setTagName(optionsList);
  }, [totalworkunitData]);

  const appFiltersSelected = useSelector((state) => state.filter?.selected);
  const [textSearch, setTextSearch] = useState('');
  useLayoutEffect(() => {
    dispatch(clearSelectedFilterAction());
    return () => {
      dispatch(clearSelectedFilterAction());
    };
  }, []);

  const onPageSizeChange = (pageSize: number) => {
    dispatch(changePageSizeAction(pageSize));
    dispatch(filterTotalFlagAction(true));
  };

  const onPageChange = (page: number) => {
    setCurrentPageVal(page);
    dispatch(changePageAction(Number(page)));
    setTimeout(() => {
      dispatch(filterTotalFlagAction(true));
    }, 500);
  };

  // useEffect(() => {
  //   // const handler = setTimeout(() => {
  //   console.log(currentPageVal);
  //   dispatch(changePageAction(Number(currentPageVal)));
  //   dispatch(filterTotalFlagAction(true));
  //   // }, 500);

  //   // return () => {
  //   //   clearTimeout(handler);
  //   // };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [currentPageVal]);

  const onSortModelChange = React.useCallback((sortModel: GridSortModel) => {
    dispatch(sortChangebaseLineAction(sortModel));
    dispatch(filterTotalFlagAction(true));
  }, []);

  const getRowClassName = useCallback((params: GridRowClassNameParams) => {
    if (params.row.label && params.row.label.includes('cancelled')) return 'Mui-disabled';
    return params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd';
  }, []);

  const constructSearchParams = async () => {
    const searchParams: SearchParams = {
      // order_id: parseInt(match.params.order_id, 10),
      // order_id: baseLineOrder?.id,
      size: pageSize,
      page: currentPage,
      // is_archived: 0,
      join: ['scope', 'consultant', 'client', 'delivery_manager'],
      // workunit_id: '>=0', // custom value so removed here
    };

    const not_submitted = ',200';
    if (Object.values(appFiltersSelected).length) {
      Object.entries(appFiltersSelected).forEach(([field, value]) => {
        if (field === 'text_search') return;
        if (field.includes('_id') && value[0] && value[0] !== '') {
          if (field === 'mission_advancement_id' && Number(value[0]) === 100) {
            searchParams[field] = not_submitted;
          } else if (field === 'mission_advancement_id' && Number(value[0]) > 100) {
            searchParams.label = Number(value[0]) === 101 ? `:Cancelled:` : `:Deleted:`;
          } else {
            searchParams[field] = value;
          }
        } else if (field === 'purchase_order' && value.length > 0 && value[0] !== '') {
          searchParams.purchase_order = value;
        } else if (value[0] && value[0] !== '') {
          searchParams[field] = `:${value}:`;
        }
      });
    }
    //   if (textSearch) {
    //     searchParams['workunit_name,workunit_reference'] = `:${textSearch}:`;
    //   }
    return searchParams;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const handleBLTotalworkunit = async () => {
    const searchParam = await constructSearchParams();
    await handleBLTotalworkunitSearchParams(pageSize, currentPage, searchParam, setIsLoading);
    dispatch(filterTotalFlagAction(false));
  };
  useEffect(() => {
    // TODO update deliverable filter initial state to prevent double call (undefined/{})
    const hasAnyValue = Object.values(appFiltersSelected).some((value) => Array.isArray(value) && value.length > 0);

    const delayDebounceFn = setTimeout(() => {
      if (filterTotalFlag || appFiltersSelected) handleBLTotalworkunit();
    }, 800);

    return () => {
      clearTimeout(delayDebounceFn);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortBLtotalWorkunitModel, appFiltersSelected, filterTotalFlag, pageSize, currentPage]);

  const fetchFilterParams = async () => {
    if (sourceOrder?.id) {
      const baseVersion =
        sourceOrder?.baseline_version === 0 || sourceOrder?.baseline_version === null
          ? 1
          : Number(sourceOrder?.baseline_version) + 1;

      const filterParams = await fetchParamsBLFilterDeliverable(Number(sourceOrder?.id), baseVersion);
      if (filterParams) {
        setFilterParamlist(filterParams);
        // dispatch(updateParamsFilterAction(filterParams));
      }
    }
  };

  useEffect(() => {
    fetchFilterParams();
  }, [filterTotalFlag]);
  const onSelectionModelChange = (selectionModel: GridSelectionModel, details: GridCallbackDetails) => {
    if (selectionModel.length === totalworkunitData.length) {
      dispatch(selectAllBLDeliverablesAction(true));
    } else {
      dispatch(selectAllBLDeliverablesAction(false));
    }
    // const deliverablesIds = state.deliverables?.map((deliverable) => deliverable.id) || [];

    // const unselected = difference(deliverablesIds, selectionModel);
    // const oldUnselected = state.excludedDeliverables.filter(
    //   (excludedDeliverable) =>
    //     !selectionModel.includes(excludedDeliverable) && !deliverablesIds.includes(Number(excludedDeliverable))
    // );
    // const everyUnselected = [...oldUnselected, ...unselected];
    // dispatch(excludeBLDeliverablesAction(everyUnselected));

    // const selectedIds = state.selectedBLDeliverablesModel; // e.g., [18, 22]
    const selectedRows = totalworkunitData.filter((item) => selectionModel.includes(item.id));

    dispatch(selectBLDeliverablesListAction(selectedRows));
    dispatch(selectBLDeliverablesAction(selectionModel));
  };

  const [filterButtonEl, setFilterButtonEl] = React.useState<HTMLButtonElement | null>(null);

  const dataTableProps: Omit<DataGridProProps, 'columns'> = {
    rows: totalworkunitData,
    onColumnVisibilityModelChange,
    columnVisibilityModel,
    onSortModelChange,
    onColumnOrderChange,
    onPageChange,
  };

  const clearFilter = () => {
    // dispatch(
    //   injectTotalWorkunitsBLAction({
    //     datas: filterTotalWorkunitData,
    //     totalItems,
    //     totalPages,
    //     currentPage,
    //   })
    // );

    dispatch(selectFilterAction({ id: [], scope_id: [], purchase_order: [], mission_advancement_id: [], label: [] }));
    setTimeout(() => {
      dispatch(filterTotalFlagAction(true));
    }, 500);
  };
  return (
    <>
      <Box
        sx={{
          flexGrow: 1,
          scrollbarWidth: 'none', // Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari, Edge
          },
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} sm={6} md={2}>
            <SearchHeaderCellBL
              {...totalworkunitData}
              field="workunit_reference"
              headerName="Reference"
              options={idsWithName}
              disabled={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <SearchHeaderCell
              {...totalworkunitData}
              field="scope_id"
              headerName="Scopes"
              options={workunitScopes}
              disabled={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <SearchHeaderCellBL
              {...totalworkunitData}
              field="purchase_order"
              headerName="PO Ref"
              options={po_ref}
              disabled={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <SearchHeaderCellBL
              {...totalworkunitData}
              field="mission_advancement_id"
              headerName="Status"
              options={statusName}
              disabled={isLoading}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <SearchHeaderCellBL
              {...totalworkunitData}
              field="label"
              headerName="Tags"
              options={tagName ?? []}
              disabled={isLoading}
            />
          </Grid>
          {/* <Grid item xs={12} sm={6} md={2}>
            <Button
              variant="outlined"
              onClick={() => clearFilter()}
              color="error"
              // startIcon={<Remove />}
              size="small"
              sx={{ mt: 3 }}
            >
              {t('Clear_filters')}
            </Button>
          </Grid> */}
        </Grid>
      </Box>
      <Box
        sx={{
          height: '72vh',
          overflow: 'auto',
          scrollbarWidth: 'none', // Firefox
          '&::-webkit-scrollbar': {
            display: 'none', // Chrome, Safari, Edge
          },
        }}
      >
        <DataGridPro
          initialState={{
            pinnedColumns: { left: [GRID_CHECKBOX_SELECTION_COL_DEF.field, 'id', 'tags', 'workunit_name'] },
          }}
          columns={columnsParams(scopes)}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: LinearProgress,
          }}
          componentsProps={{
            loadingOverlay: { style: { zIndex: 9999 } },
            panel: {
              anchorEl: filterButtonEl,
              placement: 'bottom-end',
            },
            toolbar: {
              setFilterButtonEl,
            },
          }}
          loading={isLoading}
          className={selectedBLAllDeliverables ? 'test' : ''}
          {...dataTableProps}
          apiRef={apiRef}
          autoHeight={false}
          pagination
          disableColumnMenu
          headerHeight={100}
          rowHeight={80}
          onPageSizeChange={onPageSizeChange}
          pageSize={pageSize}
          rowsPerPageOptions={[10, 25, 50, 100, 200]}
          page={currentPageVal}
          paginationMode="server"
          sortingMode="server"
          keepNonExistentRowsSelected
          disableSelectionOnClick
          rowCount={totalItems}
          selectionModel={selectedBLDeliverablesModel}
          // onPageChange={onPageChange}
          //   onSortModelChange={onSortModelChange}
          onSelectionModelChange={onSelectionModelChange}
          getRowClassName={getRowClassName}
          // checkboxSelection: !state.selectedAllDeliverables, // TODO ignore unselect or select after a select all
          checkboxSelection
          sx={{
            '& .Mui-disabled': {
              background: '#e1e5ef',
              opacity: '.9',
              pointerEvents: 'initial',
            },
            overflow: 'auto',
            mb: { xs: 30, md: 10 },
            ...(selectedBLAllDeliverables && {
              '& .MuiDataGrid-cellCheckbox .MuiCheckbox-root.Mui-checked': {
                color: '#ff0000',
              },
              '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.Mui-checked': {
                color: '#ff0000',
              },
              '& .MuiDataGrid-columnHeaderCheckbox .MuiCheckbox-root.MuiCheckbox-indeterminate': {
                color: '#ff0000',
              },
            }),
          }}
        />
      </Box>
      {selectedBLDeliverablesModel?.length !== 0 && <DeliverableQuickActions />}
    </>
  );
};

export default EditTotalWorkunit;
